var map = {
	"./de/forgot.svg": 47745,
	"./en/forgot.svg": 96329,
	"./es/forgot.svg": 35522,
	"./fr/forgot.svg": 69926,
	"./it/forgot.svg": 7507,
	"./ko/forgot.svg": 75192,
	"./pl/forgot.svg": 64562,
	"./pt/forgot.svg": 87354,
	"./ru/forgot.svg": 52007,
	"./tr/forgot.svg": 73096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50764;